import { ALIGN_CLASSES_INVERSE as e } from "./constants.js";
import { decodeAttributes as t } from "./utils/attribute-encoding.js";
import { BlockListParser as n, DocumentHtmlEntityDecoder as r } from "@intercom/interblocks.ts";
//#region src/text-block-parser.ts
var i = class {
	schema;
	documentBuilder;
	blockAttrs;
	markMap;
	nodeMap;
	marks = [
		"b",
		"i",
		"a",
		"code",
		"u",
		"span"
	];
	nodes = [
		"p",
		"br",
		"ol",
		"ul",
		"li",
		"h1",
		"h2",
		"h3",
		"h4",
		"small",
		"pre",
		"img"
	];
	customInlineHandlers;
	config;
	constructor(e, t) {
		this.documentBuilder = e, this.config = t, this.schema = e.schema, this.markMap = {
			b: this.schema.marks.bold,
			i: this.schema.marks.italic,
			a: this.schema.marks.anchor,
			code: this.schema.marks.code,
			u: this.schema.marks.underline,
			span: this.schema.marks.span
		}, this.nodeMap = {
			p: this.schema.nodes.paragraph,
			ol: this.schema.nodes.orderedList,
			ul: this.schema.nodes.unorderedList,
			li: this.schema.nodes.listItem,
			h1: this.schema.nodes.heading,
			h2: this.schema.nodes.subheading,
			h3: this.schema.nodes.subheading3,
			h4: this.schema.nodes.subheading4,
			small: this.schema.nodes.small,
			pre: this.schema.nodes.codeBlock,
			br: this.schema.nodes.hardBreak,
			hr: this.schema.nodes.horizontalLine,
			template: this.schema.nodes.template,
			mention: this.schema.nodes.mention,
			aiPromptData: this.schema.nodes.aiPromptData,
			img: this.schema.nodes.inlineImage
		}, this.customInlineHandlers = t.customInlineHandlers ?? [];
		for (let e of this.customInlineHandlers) this.nodeMap[e.name] = this.schema.nodes[e.name];
	}
	handle(e, t) {
		n.parse([e], new r(document), !!this.nodeMap.template, this.config.isPlaintext, !0, !1, !1).body.forEach((e) => this.handleNode(e, t));
	}
	handleNode(e, t) {
		if (e.isElement) {
			for (let t of this.customInlineHandlers) if (t.detect(e)) {
				t.parse(e, this);
				return;
			}
			if (this.isMention(e)) this.mention(e);
			else if (this.isAiPromptData(e)) this.aiPromptData(e);
			else if (this.marks.includes(e.value ?? "")) this.mark(e);
			else if (this.nodes.includes(e.value ?? "")) this.node(e, t);
			else throw Error(`unknown element type: ${e.value}`);
		} else e.isLiteral ? this.documentBuilder.addText(e.value ?? "") : e.type === "Template" ? this.template(e) : (this.stashBlockAttrs(e), this.handleChildren(e.children ?? [], t));
	}
	node(e, t) {
		let n = this.nodeMap[e.value ?? ""];
		if (!n) return;
		let r = this.collectAttrs(e), i = this.consumeBlockAttrs();
		if (this.addAlignment(r, i), this.addStyle(r), n === this.nodeMap.img) {
			let t = e.attributes?.find((e) => e.name === "alt");
			t && (r.text = t.value);
			let n = e.attributes?.find((e) => e.name === "data-class-name");
			n && (r.className = n.value);
		}
		if (this.documentBuilder.openNode(n, r), n === this.nodeMap.li) {
			let e = this.nodeMap.p;
			this.documentBuilder.openNode(e, {});
		}
		this.handleChildren(e.children ?? [], t), n === this.nodeMap.li && this.documentBuilder.closeNode(), this.documentBuilder.closeNode(), this.addExtraParagraphIfLegacyParagraph(e, i, t);
	}
	mark(e) {
		let t = this.markMap[e.value ?? ""], n;
		t && this.documentBuilder.top().type.allowsMarkType(t) && (n = t.create(this.collectAttrs(e)), this.documentBuilder.openMark(n), t === this.markMap.a && this.handleInlineImageLinkUrl(n, e)), this.handleChildren(e.children ?? []), n && this.documentBuilder.closeMark(n);
	}
	mention(e) {
		let t = this.collectAttrs(e);
		this.nodeMap.mention && (this.documentBuilder.openNode(this.nodeMap.mention, {
			name: e.children?.[0]?.value ?? "",
			uri: t.href
		}), this.documentBuilder.closeNode());
	}
	aiPromptData(e) {
		let t = this.collectAttrs(e), n = {};
		for (let [e, r] of Object.entries(t)) if (typeof e == "string" && e.startsWith("data-prompt-data-")) {
			let t = e.split("-").slice(3).map((e, t) => t === 0 ? e : e.charAt(0).toUpperCase() + e.slice(1)).join("");
			n[t] = String(r);
		}
		t = n, this.nodeMap.aiPromptData && (this.documentBuilder.openNode(this.nodeMap.aiPromptData, t), this.documentBuilder.closeNode());
	}
	template(e) {
		this.nodeMap.template && (this.documentBuilder.openNode(this.nodeMap.template, {
			attributePath: e.value ?? "",
			fallback: e.fallback ?? ""
		}), this.documentBuilder.closeNode());
	}
	handleInlineImageLinkUrl(e, t) {
		if (t.children?.length === 1 && t.children[0]?.value === "img") {
			let n = e.attrs.href ?? "";
			t.children[0].attributes?.push({
				type: "Attribute",
				name: "linkUrl",
				value: n
			});
		}
	}
	collectAttrs(e) {
		let n = {};
		return e.attributes?.forEach((e) => {
			let r = t(e.value);
			n[e.name] ? n[e.name] += ` ${r}` : n[e.name] = r;
		}), e.type === "Block" && (n.type = e.value), e.isElement && e.id && (n.idAttribute = e.id), n;
	}
	stashBlockAttrs(e) {
		this.blockAttrs = this.collectAttrs(e);
	}
	consumeBlockAttrs() {
		let e = this.blockAttrs;
		return this.blockAttrs = void 0, e;
	}
	addAlignment(t, n) {
		!n || typeof n.class != "string" || n.class.split(" ").forEach((n) => {
			let r = e[n];
			r && Object.assign(t, { alignment: r });
		});
	}
	addStyle(e) {
		!e || typeof e.style != "string" || e.style.split(";").forEach((t) => {
			if (!t) return;
			let n = t.split(":", 2), r = n[0], i = n[1].trim();
			r === "font-family" && Object.assign(e, { fontFamily: i }), r === "color" && Object.assign(e, { fontColor: i }), r === "width" && Object.assign(e, { width: i.replace("px", "") });
		});
	}
	handleChildren(e, t) {
		e.forEach((e) => {
			this.handleNode(e, t);
		});
	}
	isMention(e) {
		return !!(this.nodeMap.mention && e.value === "a" && e.attributes?.find((e) => e.name === "class" && e.value === "entity_mention"));
	}
	isAiPromptData(e) {
		return !!(this.nodeMap.aiPromptData && e.value === "span" && e.attributes?.find((e) => e.name === "data-ai-prompt-data"));
	}
	addExtraParagraphIfLegacyParagraph(e, t, n) {
		this.isParagraphWithImplicitMargin(e, t, n) && !this.config.singleBlockMode && !this.config.allowImplicitMarginParagraphs && (this.documentBuilder.openNode(this.nodeMap.p, {}), this.documentBuilder.closeNode());
	}
	isParagraphWithImplicitMargin(e, t, n) {
		return !t || !n ? !1 : e.value === "p" && !t.class.includes("no-margin");
	}
};
//#endregion
export { i as TextBlockParser };
